import React from 'react';

import Defaults from '../../../shared/constants/defaults';
import FormSettings from '../../../shared/constants/form-settings';

import TinyMCE from 'react-tinymce';

export default class FormClosedMessageSection extends React.Component {
	render() {
		// TinyMCE resolves the path to tinymce.css in a relative way, so the context
		// needs to be setup for each component using it.  Ohhhh, TinyMCE....
		let tinyMCECssPathContext = '../../../';
		let tinyMCEConfig = {
			...Defaults.TINYMCE_CONFIG,
			toolbar_drawer: '',
			contextmenu: false
		};
		let { localization } = this.props;
		
		tinyMCEConfig.content_css = tinyMCEConfig.content_css.replace(':pathContext:', tinyMCECssPathContext);
		
		return (
			<section className='form-closed-message'>
				<label>
					{localization.substitute('Message after form closes')}
				</label>

				<TinyMCE
					content={localization.substitute(this.props.message)}
					config={tinyMCEConfig}
					onBlur={this.handleContentChange.bind(this, FormSettings.FORM_CLOSED_MESSAGE)}
				/>
			</section>
		);
	}
	
	handleContentChange = (propertyName, evt) => {
		let rteContent = evt.target.getContent();
		this.props.updateCallback(propertyName, rteContent);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/advanced-settings/components/sections/form-closed-message.js